module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/1@2x_03d6365d3a5d5b6ac0432ff5513ac3b4.png";